export interface IEnvironment {
    production: boolean;
    apiBaseUrl: string;
    defaultAppUrl: string;
    remitAppUrl: string;
    adminAppUrl: string;
    phiAppUrl: string;
    studiesAppUrl: string;
    clinicAppUrl: string;
    healthpayAppUrl: string;
    automateAppUrl: string;
    custodianAppUrl: string;
    threadsAppUrl: string;
    engageAppUrl:string;
    billerAppUrl: string;
    chartsAppUrl: string;
    betaAppUrl: string;
    chartsV2AppUrl: string;
    signatureAppUrl: string;
    signatureKey: string;
    /** Company/org to attach newly signed-up Entra users to. */
    defaultSignupOrganizationId: string;
    /** Default post-logout redirect (Aya / Lovable app). */
    ayaAppUrl: string;
    /** Health Exam chat (Lovable); default return from OAuth /redirect bridge. */
    ayaHealthChatAppUrl: string;
    /** Same OAuth client as Entra Google IdP — for linking google.com after email sign-in. */
    googleOAuthClientId?: string;
    /**
     * Email OTP: true = Accounts BFF (`login/entra/start`).
     * false = browser MSAL Custom Auth via same-origin `/api` Entra proxy.
     */
    entraEmailOtpViaBff?: boolean;
    /**
     * Email OTP identity provider — mirrors backend EMAIL_OTP_IDP.
     * `entra` = MSAL / Entra Native Auth (default).
     * `google` = Firebase + ACS OTP; enables Continue with Google/Apple.
     * `entra` = buttons visible but disabled.
     * Set per build config: environment.local.ts, environment.staging.ts, etc.
     */
    emailOtpIdp?: 'entra' | 'google';
    /**
     * Google email delivery when emailOtpIdp is `google` (mirrors GOOGLE_EMAIL_OTP_DELIVERY).
     * `acs` — 6-digit OTP via Accounts BFF + Azure Communication Services (default).
     * `twilio_verify` — Twilio Verify email OTP (send + verify via Twilio).
     * `firebase_passwordless` — Firebase passwordless email sign-in link.
     */
    googleEmailOtpDelivery?: 'acs' | 'twilio_verify' | 'firebase_passwordless';
    /** Firebase client config — required when emailOtpIdp is `google`. */
    firebase?: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    };
    /**
     * When true (default for `emailOtpIdp: google`), after Health Exam logout
     * completes the browser is sent to accounts.google.com/Logout. Set false
     * to skip and use the normal post-logout redirect instead.
     */
    googleBrowserLogoutOnSignOut?: boolean;
}

export enum AvailableApplication {
    Admin = 'admin',
    Remit = 'remit',
    Phi = 'phi',
    Biller = 'biller',
    Studies = 'studies',
    Charts = 'charts',
    Referral = 'referral',
    Beta = 'beta',
    Clinic = 'clinic',
    HealthPay = 'healthpay',
    Automate = 'automate',
    Custodian = 'custodian',
    Threads = 'threads',
    ChartsV2 = 'chartsv2',
    Signature = 'sign',
    Engage = 'engage',
    Vascunote = 'vascunote'
}
